/**
 * Vendor panel access from GET /getVendorProfile `vendor.service_type`.
 * shop | rent | service — each vendor sees only their module.
 */

const STORAGE_KEY = "vendorServiceType";

export function normalizeVendorServiceType(raw) {
  const t = String(raw || "")
    .trim()
    .toLowerCase();
  if (t === "shop" || t === "rent" || t === "service") return t;
  return "";
}

export function persistVendorServiceType(raw) {
  const t = normalizeVendorServiceType(raw);
  if (t) localStorage.setItem(STORAGE_KEY, t);
  else localStorage.removeItem(STORAGE_KEY);
  return t;
}

export function getStoredVendorServiceType() {
  return normalizeVendorServiceType(localStorage.getItem(STORAGE_KEY));
}

export function resolveVendorServiceType(vendorProfile) {
  return (
    normalizeVendorServiceType(vendorProfile?.service_type) ||
    getStoredVendorServiceType()
  );
}

export function vendorModuleAccess(serviceType) {
  const t = normalizeVendorServiceType(serviceType);
  if (!t) {
    return { shop: true, rent: true, service: true };
  }
  return {
    shop: t === "shop",
    rent: t === "rent",
    service: t === "service",
  };
}

export function homePathForServiceType(serviceType) {
  const t = normalizeVendorServiceType(serviceType);
  if (t === "rent") return "/product-management/rent";
  if (t === "service") return "/service-management";
  if (t === "shop") return "/product-management/shop";
  return "/dashboard";
}

function isServiceModulePath(pathname) {
  const p = String(pathname || "");
  return (
    p.startsWith("/service-management") ||
    p.startsWith("/package-management") ||
    p.startsWith("/booking-management")
  );
}

function isShopModulePath(pathname) {
  const p = String(pathname || "");
  return (
    p.includes("/product-management/shop") ||
    p.includes("/merchant-management/shop") ||
    p === "/product-management" ||
    p === "/merchant-management"
  );
}

function isRentModulePath(pathname) {
  const p = String(pathname || "");
  return (
    p.includes("/product-management/rent") ||
    p.includes("/merchant-management/rent")
  );
}

function isProductOrMerchantPath(pathname) {
  const p = String(pathname || "");
  return (
    p.startsWith("/product-management") ||
    p.startsWith("/merchant-management") ||
    p.startsWith("/inventory")
  );
}

/** False = this URL is not allowed for the vendor's service_type. */
export function isPathAllowedForServiceType(pathname, serviceType) {
  const t = normalizeVendorServiceType(serviceType);
  if (!t) return true;
  if (t === "shop") {
    return !isServiceModulePath(pathname) && !isRentModulePath(pathname);
  }
  if (t === "rent") {
    return !isServiceModulePath(pathname) && !isShopModulePath(pathname);
  }
  if (t === "service") {
    return !isProductOrMerchantPath(pathname);
  }
  return true;
}
